/* ============================================================
   ALAYNE RITTANO THEME — behavior
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav ---------- */
  var mobileToggle = document.getElementById('mobileToggle');
  var navlinks = document.getElementById('navlinks');
  if (mobileToggle && navlinks) {
    mobileToggle.addEventListener('click', function () {
      navlinks.classList.toggle('open');
    });
    navlinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { navlinks.classList.remove('open'); });
    });
  }

  /* ---------- Quantity steppers (product page + cart) ---------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input[type="number"]');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);

    function setVal(v) {
      v = Math.max(min, v);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () { setVal(parseInt(input.value || '1', 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setVal(parseInt(input.value || '1', 10) + 1); });
  });

  /* ---------- Product form: variant swap + price + media ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
    var productJson = formEl.querySelector('[data-product-json]');
    if (!productJson) return;
    var product = JSON.parse(productJson.textContent);
    var priceEl = formEl.querySelector('[data-product-price]');
    var comparePriceEl = formEl.querySelector('[data-product-compare-price]');
    var btnPriceEl = formEl.querySelector('[data-btn-price]');
    var addBtn = formEl.querySelector('[data-add-to-cart]');
    var qtyInput = formEl.querySelector('[data-qty-input]');
    var variantIdInput = formEl.querySelector('[data-variant-id]');
    var media = document.querySelectorAll('[data-variant-media="' + product.id + '"]');

    function money(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      var value = (cents / 100);
      var withComma = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d)\.)/g, ',');
      var noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d)$)/g, ',');
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));
    }

    function findVariant() {
      var selected = {};
      formEl.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(function (input) {
        selected[input.dataset.optionIndex] = input.value;
      });
      return product.variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v.options[idx] === selected[idx];
        });
      });
    }

    function render() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (addBtn) {
        if (!variant.available) {
          addBtn.disabled = true;
          addBtn.querySelector('[data-btn-label]') && (addBtn.querySelector('[data-btn-label]').textContent = 'Sold out');
          if (btnPriceEl) btnPriceEl.style.display = 'none';
        } else {
          addBtn.disabled = false;
          addBtn.querySelector('[data-btn-label]') && (addBtn.querySelector('[data-btn-label]').textContent = 'Add to cart');
          if (btnPriceEl) { btnPriceEl.style.display = ''; btnPriceEl.textContent = money(variant.price * qty); }
        }
      }
      media.forEach(function (el) {
        var show = !el.dataset.variantMediaId || el.dataset.variantMediaId === String(variant.featured_media ? variant.featured_media.id : '');
        el.style.display = show ? '' : 'none';
      });
    }

    formEl.querySelectorAll('input[type="radio"][data-option-index]').forEach(function (input) {
      input.addEventListener('change', render);
    });
    if (qtyInput) qtyInput.addEventListener('change', render);
    render();

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var formData = new FormData(formEl);
      if (addBtn) { addBtn.disabled = true; addBtn.classList.add('added'); }

      fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            // Shopify error payload
            if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('added'); }
            alert(data.description || 'That item could not be added to your cart.');
            return;
          }
          updateCartCount();
          if (window.themeCartType === 'page') {
            window.location.href = '/cart';
            return;
          }
          showCartNotification(data);
          if (addBtn) {
            var label = addBtn.querySelector('[data-btn-label]');
            if (label) label.textContent = 'Added';
            setTimeout(function () {
              if (label) label.textContent = 'Add to cart';
              addBtn.disabled = false;
              addBtn.classList.remove('added');
            }, 1800);
          }
        })
        .catch(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('added'); }
        });
    });
  });

  /* ---------- Product media thumbnails ---------- */
  document.querySelectorAll('[data-thumb-group]').forEach(function (group) {
    var mainImg = document.querySelector('[data-main-media="' + group.dataset.thumbGroup + '"] img');
    group.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        group.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg && thumb.dataset.fullSrc) mainImg.src = thumb.dataset.fullSrc;
      });
    });
  });

  /* ---------- Cart notification ---------- */
  function showCartNotification(item) {
    var el = document.getElementById('cart-notification');
    if (!el) return;
    var text = document.getElementById('cart-notification-text');
    if (text && item && item.title) text.textContent = 'Added — ' + item.product_title;
    el.classList.add('show');
    clearTimeout(window.__cartNotifTimer);
    window.__cartNotifTimer = setTimeout(function () { el.classList.remove('show'); }, 4200);
  }

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }

  /* ---------- Cart page: quantity change via /cart/change.js ---------- */
  document.querySelectorAll('[data-cart-line-qty]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var line = stepper.dataset.cartLineQty;
    if (!input) return;
    input.addEventListener('change', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });
  document.querySelectorAll('[data-cart-line-remove]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var line = btn.dataset.cartLineRemove;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Contact / generic forms: nothing extra needed, native Shopify form handles submit ---------- */
});
